import type { ReactElement } from "react";
import type { ItemTrendPoint } from "./itemTrend";

/** Рендер точки линии в режиме %: рисует кружок только у ИЗОЛИРОВАННОЙ точки (оба соседа — null
 *  или их нет): иначе линия без соседей не оставляет на графике ничего. */
export function isolatedDot(
  points: readonly ItemTrendPoint[],
  key: "cur" | "cmp",
  color: string,
): (props: { cx?: number; cy?: number; index?: number }) => ReactElement {
  const DotView = (props: { cx?: number; cy?: number; index?: number }): ReactElement => {
    const { cx, cy, index } = props;
    const i = index ?? -1;
    const isolated =
      i >= 0 &&
      points[i]?.[key] != null &&
      (i === 0 || points[i - 1]![key] == null) &&
      (i === points.length - 1 || points[i + 1]![key] == null);
    return isolated && cx !== undefined && cy !== undefined ? (
      <circle cx={cx} cy={cy} r={2.5} fill={color} stroke={color} />
    ) : (
      <g />
    );
  };
  return DotView;
}
